import { tv } from 'tailwind-variants'

export const flowPreviewButtonVariants = tv({
  slots: {
    base: 'w-[60%]'
  },
  variants: {
    fullWidth: {
      true: 'w-full'
    },
    source: {
      CLIENT:
        'self-start text-info-medium bg-secondary-xlight hover:text-white hover:bg-secondary-medium disabled:bg-secondary-medium active:bg-secondary-medium',
      PRODUCT:
        'self-end text-white bg-secondary-medium hover:bg-secondary-dark disabled:bg-secondary-dark active:bg-secondary-dark'
    }
  }
})
